<template>
  <!-- 入库处理 하단 — 핸드폰 入库拍照(/m/import-photo)에서 「完成」한 주문이 들어온 순서대로(2026-10-07 YZY).
       30초마다 읽는다. 행을 누르면 부모(logisaddimportV0)가 그 주문을 검색해 연다. 처리하면 done -->
  <div class="iphq">
    <div class="iphq__head">
      <strong>📷 待处理拍照<small>(촬영 대기열)</small></strong>
      <b-badge :variant="rows.length ? 'danger' : 'secondary'" pill class="ml-1">{{ rows.length }}</b-badge>
      <small class="text-muted ml-2">每30秒刷新(30초마다 갱신)</small>
      <b-button size="sm" variant="link" class="p-0 ml-2" :disabled="loading" @click="load">↻ 刷新(새로고침)</b-button>
      <b-button size="sm" variant="outline-dark" class="ml-auto" @click="openQr">📱 手机拍照二维码<small>(핸드폰 촬영 QR)</small></b-button>
    </div>
    <div v-if="error" class="small text-danger">{{ error }}</div>
    <table v-if="rows.length" class="table table-sm table-hover mb-0 iphq__table">
      <thead class="thead-light">
        <tr>
          <th style="width:90px">时间<small>(시각)</small></th>
          <th style="width:120px">作业人<small>(작업자)</small></th>
          <th>单号<small>(번호)</small></th>
          <th style="width:120px">货主<small>(화주)</small></th>
          <th style="width:80px">商品<small>(건)</small></th>
          <th style="width:80px">照片<small>(사진)</small></th>
          <th style="width:110px"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="r in rows" :key="r._id" :class="['iphq__row', { 'table-warning': r._id === activeId }]" @click="open(r)">
          <td>{{ timeText(r.시각) }}</td>
          <td :title="r.작업자 && r.작업자.계정">{{ (r.작업자 && r.작업자.이름) || '-' }}</td>
          <td><small class="text-muted">{{ typeText(r.검색타입) }}</small> <b>{{ r.번호 }}</b></td>
          <td class="small">{{ (r.화주 || []).join(', ') }}</td>
          <td>{{ (r.reqIds || []).length }}</td>
          <td>📷 {{ r.사진수 || 0 }}</td>
          <td class="text-right" @click.stop>
            <span v-if="r._id === activeId" class="small text-warning mr-1">处理中</span>
            <b-button size="sm" variant="outline-success" :disabled="busyId === r._id" @click="done(r._id)">处理完<small>(완료)</small></b-button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else-if="!loading" class="small text-muted py-2">暂无(없음) — 用手机扫码拍照后会显示在这里(핸드폰으로 찍고 「完成」하면 여기에 순서대로 뜹니다)</div>

    <!-- 고정 주소 QR — 토큰 없음(직원 계정 로그인, /m/inbound-register 와 같은 방식). 인쇄해서 붙여 둔다 -->
    <b-modal v-model="qr.show" hide-footer title="📱 手机入库拍照(핸드폰 입고 촬영)">
      <div ref="printArea" class="text-center">
        <img v-if="qr.img" :src="qr.img" alt="" style="width:320px;height:320px">
        <div class="mt-2" style="font-size:20px;font-weight:700">入库拍照 · 扫码打开</div>
        <div class="small mt-1" style="word-break:break-all">{{ qr.url }}</div>
      </div>
      <div class="small text-muted mt-2 text-center">用手机扫码打开，用员工账号登录(핸드폰으로 열고 직원 계정으로 로그인)</div>
      <div class="small text-muted text-center">扫单号 → 拍照 → 完成 → 电脑这里按顺序显示(번호 → 촬영 → 완료 → 이 화면에 순서대로)</div>
      <div class="text-center mt-3">
        <b-button variant="primary" @click="printQr">🖨️ 打印(인쇄)</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import qrcode from 'qrcode-generator';

const POLL_MS = 30 * 1000;
const TYPE_TEXT = { tracking: '快递单号', order: '货主订单号', order1688: '1688订单号' };

function phoneUrl() {
  return window.location.origin + '/m/import-photo';
}
function makeQr(url, cell) {
  const qr = qrcode(0, 'M');
  qr.addData(url);
  qr.make();
  return qr.createDataURL(cell, 4);
}

export default {
  name: 'ImportPhotoQueueList',
  props: {
    // 入库处理 탭이 보일 때만 폴링
    active: { type: Boolean, default: true },
    // 지금 열어 둔 줄(부모가 정한다)
    activeId: { type: String, default: '' }
  },
  data() {
    return {
      rows: [],
      loading: false,
      error: '',
      busyId: '',
      timer: null,
      qr: { show: false, url: '', img: '' }
    };
  },
  watch: {
    active(v) {
      if (v) this.load();
    }
  },
  mounted() {
    this.load();
    this.timer = setInterval(() => {
      if (this.active && !document.hidden) this.load();
    }, POLL_MS);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    typeText(t) {
      return TYPE_TEXT[t] || t || '';
    },
    // 시각 → MM-DD HH:mm(이 PC 시간대)
    timeText(v) {
      const d = new Date(v);
      if (!Number.isFinite(d.getTime())) return '';
      const p = n => String(n).padStart(2, '0');
      return p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
    },
    async load() {
      if (this.loading) return;
      this.loading = true;
      try {
        const { data } = await axios.post('/api/importPhotoQueue/list', {});
        if (data.요청결과 !== '성공') {
          this.error = '读取失败(불러오기 실패): ' + ((data.error && data.error.errorMessage) || '');
          return;
        }
        this.error = '';
        this.rows = data.rows || [];
        this.$emit('count', this.rows.length);
      } catch (e) {
        console.error('[촬영 대기열] 불러오기 오류:', e);
        this.error = '读取错误(불러오기 오류): ' + e.message;
      } finally {
        this.loading = false;
      }
    },
    open(r) {
      this.$emit('open', r);
    },
    // 처리 끝 — 부모가 자동으로 부를 때도 이 메서드(같은 줄을 두 번 불러도 서버가 한 번만 바꾼다)
    async done(id) {
      if (!id || this.busyId === id) return false;
      this.busyId = id;
      try {
        const { data } = await axios.post('/api/importPhotoQueue/done', { _id: id });
        if (data.요청결과 !== '성공') {
          alert('处理失败(완료 처리 실패): ' + ((data.error && data.error.errorMessage) || ''));
          return false;
        }
        this.rows = this.rows.filter(r => r._id !== id);
        this.$emit('count', this.rows.length);
        this.$emit('done', id);
        return true;
      } catch (e) {
        console.error('[촬영 대기열] 완료 처리 오류:', e);
        alert('处理错误(완료 처리 오류): ' + e.message);
        return false;
      } finally {
        this.busyId = '';
      }
    },
    openQr() {
      const url = phoneUrl();
      this.qr = { show: true, url, img: makeQr(url, 10) };
    },
    // QR 만 새 창에 크게 띄워 인쇄한다(입고처리 화면 전체가 찍히지 않게)
    printQr() {
      const w = window.open('', '_blank', 'width=600,height=700');
      if (!w) {
        alert('请允许弹出窗口(팝업을 허용해 주세요)');
        return;
      }
      w.document.write('<html><head><title>入库拍照</title></head><body style="text-align:center;font-family:sans-serif">' +
        '<img src="' + this.qr.img + '" style="width:420px;height:420px"><div style="font-size:28px;font-weight:700;margin-top:12px">入库拍照 · 扫码打开</div>' +
        '<div style="font-size:14px;margin-top:6px">' + this.qr.url + '</div><div style="font-size:14px;margin-top:6px">用员工账号登录 → 扫单号 → 拍照 → 完成</div></body></html>');
      w.document.close();
      w.focus();
      setTimeout(() => {
        try {
          w.print();
        } catch (e) {
          console.error('[촬영 대기열] QR 인쇄 오류:', e);
        }
      }, 300);
    }
  }
};
</script>

<style lang="scss" scoped>
.iphq {
  margin-top: 24px;
  padding-top: 12px;
  border-top: 2px solid #e9ecef;
  &__head { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; margin-bottom: 6px; }
  &__row { cursor: pointer; }
  &__table td { vertical-align: middle; }
}
</style>
